import axios from 'axios'
import { journalUrl, getHeader } from './../config'

const state = {
  journalTypes: [],
  journalContacts: [],
  journalTampungan: [],
  journalTemplateList: [],
  journal: {
    id: null,
    journal_code: null,
    journal_date: null,
    ref_no: null,
    contact: null,
    journal_description: null,
    type_id: null,
    status: null,
    debit: '0',
    credit: '0',
    branch_no: null,
    ledger_id: null,
    book_no: null,
    lock: null,
    org_id: null,
    company_no: null,
    company: null,
    details: [{
      id: null,
      journal_code: null,
      account_code: null,
      account_name: null,
      remark: null,
      debit: '0',
      credit: '0',
      branch_no: null,
      journal_date: null,
      customer_no: null,
      customer: null,
      company_no: null
    }]
  },
  journalList: []
}

const mutations = {
  SET_TYPES (state, obj) {
    state.journalTypes = obj
  },
  SET_CONTACTS (state, obj) {
    state.journalContacts = obj
  },
  SET_JOURNAL_TAMPUNGAN (state, obj) {
    state.journalTampungan = obj
  },
  SET_JOURNAL_TEMPLATE_LIST (state, obj) {
    state.journalTemplateList = obj
  },
  SET_JOURNAL (state, obj) {
    state.journal = obj
  },
  SET_JOURNAL_LIST (state, obj) {
    state.journalList = obj
  }
}

const actions = {
  getJournalTemplateList: ({ commit }) => {
    axios.get(journalUrl + '/template', { headers: getHeader() })
      .then(response => {
        commit('SET_JOURNAL_TEMPLATE_LIST', response.data.data)
      })
  },
  getJournalTypes: ({ commit }) => {
    axios.get(journalUrl + '/type', { headers: getHeader() })
      .then(response => {
        commit('SET_TYPES', response.data.data)
      })
  },
  getJournalContacts: ({ commit }) => {
    axios.get(journalUrl + '/contact', { headers: getHeader() })
      .then(response => {
        commit('SET_CONTACTS', response.data.data)
      })
  },
  getJournalTampungan: ({ commit }) => {
    axios.get(journalUrl + '/tampungan-leasing', { headers: getHeader() })
      .then(response => {
        commit('SET_JOURNAL_TAMPUNGAN', response.data.data)
      })
  },
  getJournal: ({ commit }, payload) => {
    axios.get(journalUrl + '/' + payload, { headers: getHeader() })
      .then(response => {
        commit('SET_JOURNAL', response.data.data)
      })
  },
  getJournalList: ({ commit }, payload) => {
    const url = journalUrl + '?begin=' + payload.begin + '&end=' + payload.end + '&auto=' + payload.auto
    axios.get(url, { headers: getHeader() })
      .then(response => {
        commit('SET_JOURNAL_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
